/* eslint semi:0 */
import { appDispatcher } from '../../application/AppDispatcher'
import { namespacedConsts } from '../../utils/object'
import { queryString } from '../../utils/window'
import { info } from '../../application/console'

const { debugAnalyticsClickHandler } = queryString
export const CLASS_CONSTATNTS = namespacedConsts({
  ANALYTICS: {
    ACTIONS: {
      CLICK_EVENT: true,
      PAGE_VIEWED: true,
      HEART_BEAT: true,
      SCROLL_ANCHOR_REACHED: true,
      TIME_ON_PAGE_INTERVAL: true,
      RIDDLE_EMBED_MESSAGE: true,
    },
  },
})
export const PAGEVIEW_ACTION = { type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.PAGE_VIEWED }

export const TYPES = CLASS_CONSTATNTS.ANALYTICS.ACTIONS

export function riddleEmbedMessage(payload) {
  appDispatcher.dispatchAction.view({
    type: TYPES.RIDDLE_EMBED_MESSAGE,
    payload,
  })
}

export function pageViewed() {
  appDispatcher.dispatchAction.view(PAGEVIEW_ACTION)
}

export function heartBeat() {
  appDispatcher.dispatchAction.window({
    type: TYPES.HEART_BEAT,
  })
}

export function scrollAnchorReached(payload) {
  appDispatcher.dispatchAction.view({
    type: TYPES.SCROLL_ANCHOR_REACHED,
    payload: {
      ...payload,
      anchor: `.${Array.join(payload.anchor.classList, '.')}`,
    },
    dispatchToRedux: true,
  })
}

export function timeOnPageInterval(timeOnPage) {
  appDispatcher.dispatchAction.window({
    type: TYPES.TIME_ON_PAGE_INTERVAL,
    timeOnPage,
  })
}

export function pageClicked(payload) {
  if (debugAnalyticsClickHandler) {
    info('CLICK DISPATCH PAYLOAD: ', payload)
  }
  return {
    type: TYPES.CLICK_EVENT,
    state: {
      payload,
    },
  }
}

export function shareButtonsAnalyticsAction(shareType, position) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: 'article share click',
        label: shareType,
        sub_label: position,
      },
    },
  }
}

const analyticsActions = {
  TYPES,
  riddleEmbedMessage,
  pageViewed,
  heartBeat,
  scrollAnchorReached,
  timeOnPageInterval,
  pageClicked,
}

export default analyticsActions



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/analyticsActions.js